"use client";
import { useProps } from "../../../core/MantineProvider/use-props/use-props.mjs";
import { factory } from "../../../core/factory/factory.mjs";
import { Popover } from "../../Popover/Popover.mjs";
import Combobox_module_default from "../Combobox.module.mjs";
import { useComboboxContext } from "../Combobox.context.mjs";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/Combobox/ComboboxDropdown/ComboboxDropdown.tsx
const ComboboxDropdown = factory((props) => {
	const { classNames, styles, className, style, hidden, ...others } = useProps("ComboboxDropdown", null, props);
	const ctx = useComboboxContext();
	return /* @__PURE__ */ jsx(Popover.Dropdown, {
		...others,
		role: "presentation",
		"data-hidden": hidden || void 0,
		"data-floating-height": ctx.floatingHeight || void 0,
		...ctx.getStyles("dropdown", {
			className,
			style,
			classNames,
			styles
		})
	});
});
ComboboxDropdown.classes = Combobox_module_default;
ComboboxDropdown.displayName = "@mantine/core/ComboboxDropdown";
//#endregion
export { ComboboxDropdown };

//# sourceMappingURL=ComboboxDropdown.mjs.map